import {AppVersion} from '../../types/AppVersion';
import {AppFeature} from '../../types/AppConstants';
import {AppFilterStrategy} from './AppFilterStrategy';

/**
 * Filter strategy for filtering apps by feature.
 * Checks if the app's features array includes the specified feature.
 */
export class FeatureFilterStrategy extends AppFilterStrategy<AppFeature> {
  public matches(app: AppVersion, filterValue: AppFeature | undefined): boolean {
    if (!this.isActive(filterValue)) {
      return true;
    }

    if (!app.features) {
      return false;
    }

    return app.features.includes(filterValue!);
  }
}
